import { render, staticRenderFns } from "./DtSkinDialogComponent.vue?vue&type=template&id=2af2184d&scoped=true"
import script from "./DtSkinDialogComponent.vue?vue&type=script&lang=js"
export * from "./DtSkinDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af2184d",
  null
  
)

export default component.exports